/**
 * <arcero-tech-spec> — builds the numbered image hotspots from the
 * server-rendered spec-list rows (data-hotspot-left/top/label on each
 * [data-arcero-tech-row]), then syncs hover/focus/click between a hotspot
 * and its matching row via a shared data-i index assigned here at
 * build-time. See blocks/arcero-tech-spec-row.liquid for why the list is
 * the source and the hotspots are derived, not the other way round.
 *
 * Hover/focus previews the pairing; click makes it "sticky" until another
 * row/hotspot is clicked, so the highlight survives the mouse leaving.
 */
class ArceroTechSpec extends HTMLElement {
  connectedCallback() {
    this.figure = this.querySelector('[data-arcero-tech-figure]');
    this.rows = Array.from(this.querySelectorAll('[data-arcero-tech-row]'));

    if (!this.figure || this.rows.length === 0) return;

    this.sticky = null;
    this.hotspots = [];

    this.rows.forEach((row, i) => {
      row.dataset.i = i;

      const hotspot = document.createElement('button');
      hotspot.type = 'button';
      hotspot.className = 'arcero-tech-spec__hotspot';
      hotspot.style.left = `${row.dataset.hotspotLeft}%`;
      hotspot.style.top = `${row.dataset.hotspotTop}%`;
      hotspot.dataset.i = i;
      hotspot.setAttribute('aria-label', row.dataset.label || '');
      hotspot.textContent = pad(i + 1);
      this.figure.appendChild(hotspot);
      this.hotspots.push(hotspot);

      row.addEventListener('mouseenter', () => this.setActive(i));
      row.addEventListener('mouseleave', () => this.setActive(this.sticky));
      row.addEventListener('click', () => this.setSticky(i));

      hotspot.addEventListener('mouseenter', () => this.setActive(i));
      hotspot.addEventListener('mouseleave', () => this.setActive(this.sticky));
      hotspot.addEventListener('focus', () => this.setActive(i));
      hotspot.addEventListener('blur', () => this.setActive(this.sticky));
      hotspot.addEventListener('click', () => this.setSticky(i));
    });
  }

  setSticky(i) {
    this.sticky = this.sticky === i ? null : i;
    this.setActive(this.sticky);
  }

  setActive(i) {
    this.rows.forEach((row) => row.classList.toggle('is-on', row.dataset.i === String(i)));
    this.hotspots.forEach((hotspot) => hotspot.classList.toggle('is-on', hotspot.dataset.i === String(i)));
  }
}

function pad(n) {
  return (n < 10 ? '0' : '') + n;
}

customElements.define('arcero-tech-spec', ArceroTechSpec);
